export default __webpack_public_path__ + "static/media/gwn18.2cb3bc2d.webp";